export default {
  tagsBySkillId(state) {
    return id => state.tags.filter(tag => tag.skillId === id);
  },

  tagsCount(state) {
    return state.tags.length;
  },

  tagById(state) {
    return id => state.tags.find(tag => tag.id === id);
  },
};



// WEBPACK FOOTER //
// ./src/store/videotags/getters.js